function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3012 5528",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2600.15,-149.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.42074,-1.42074,1.7192,1.7192,-1423.58,3001.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2544,485.473L2544,1947.53C2544,2004.08 2488.44,2050 2420,2050C2351.56,2050 2296,2004.08 2296,1947.53L2296,485.473C2296,428.917 2351.56,383 2420,383C2488.44,383 2544,428.917 2544,485.473Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.42074,-1.42074,1.7192,-1.7192,5452.81,9700.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2544,485.473L2544,1947.53C2544,2004.08 2488.44,2050 2420,2050C2351.56,2050 2296,2004.08 2296,1947.53L2296,485.473C2296,428.917 2351.56,383 2420,383C2488.44,383 2544,428.917 2544,485.473Z",
    style: {
      fill: "white"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6dc5c66771e5f234f9ccf1a7b1c2cd9c.svg";
export { ForwardRef as ReactComponent };